module.exports = __webpack_public_path__ + "static/approach-1-624d7629c0f8fb53804a2569c75d4646.jpg";